<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Payout Upload</h3>
        ({{sourceName}} , {{countryName}})
      </div>
    </div>
  </div>
</div>

<table  class="table table-striped table-bordered mt-3" style="width:100%">
  <thead >
    <tr class="thead-dark">
      <th class="text-center">Label</th>
      <th class="text-center">Operation</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="align-middle text-center">Download Template</td>
      <td>
        <a href="http://payres.intelligent-earnings.com/templates/upload_payout_record_template.xlsx" target="_blank"  >Download</a>
      </td>
    </tr>
    <tr>
      <td class="align-middle text-center">Upload Record</td>
      <td class="controls form-inline">
        <input type="file" class="form-control" (change)="onFileChange($event)" accept=".xlsx"/>
        <button class="btn btn-success btn-sm mr-2" (click)="uploadPayoutRecords()" *ngIf="!fileUploading">Upload</button>
        <button class="btn btn-success btn-sm mr-2" *ngIf="fileUploading" disabled>Uploading</button>
        <button class="btn btn-success btn-sm mr-2 d-none" id="uploadResultBtn" (click)="openModal(viewUploaddResult)">Open</button>
      </td>
    </tr>
  </tbody>
</table>

<ng-template #viewUploaddResult let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="uploadedResultUrl-header">Uploaded Result</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to check result:
        <a href={{uploadResultUrl}} target="_blank">
          {{uploadResultUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
